import { styled } from '@mui/material/styles';
import { Box, Grid as MuiGrid, Switch, Typography } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const Grid = styled(MuiGrid)(() => ({
  marginTop: 0,
  marginLeft: 0,
  width: '100%',
  '& .MuiGrid-item': {
    paddingTop: 0,
  },
}));

export const NotificationSettings = () => {
  const settings = [
    {
      title: 'Snooze All',
    },
    {
      title: 'Calendar Invites',
    },
    {
      title: 'Change Requests',
    },
    {
      title: 'Task Notifications',
    },
    {
      title: 'Proofing Notifications',
    },
    {
      title: 'Marketing Notifications',
    },
  ];

  return (
    <Box sx={{ paddingTop: '8px' }}>
      <Box sx={{ display: 'flex', gap: 1, p: 2 }}>
        <SettingsOutlinedIcon sx={{ color: 'secondary.darker' }} />
        <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>Notification Settings</Typography>
      </Box>
      {settings.map((item, index) => {
        return (
          <Grid
            container
            spacing={2}
            alignItems={'center'}
            key={index}
          >
            <Grid
              item
              xs={8}
            >
              <Typography sx={{ fontSize: '14px' }}>{item.title}</Typography>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{ textAlign: 'center' }}
            >
              <Switch
                inputProps={{ 'aria-label': 'controlled' }}
                onClick={(e) => e.stopPropagation()}
              />
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
};
